BX.ready(() => {
    BX.LazyLoad.LOADER_SELECTOR = 'loader-element';
    BX.LazyLoad.ON_LAZY_LOAD_EVENT_NAME = 'onLazyLoad';
    BX.LazyLoad._registerImage = BX.LazyLoad.registerImage;
    BX.LazyLoad._showImage = BX.LazyLoad.showImage;

    BX.LazyLoad.initObserver = function initObserver() {
        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
            rootMargin: '20% 0% 20% 0%',
            threshold: 0
        });
    }

    BX.LazyLoad.registerImage = function registerImage(element, isImageVisibleCallback, options) {
        const image = element.querySelector('img');

        this._registerImage((image ? image.id : element.id), isImageVisibleCallback, options);
    }

    BX.LazyLoad.showImage = function showImage(element) {
        if (this.images[element.id].status === this.imageStatus.loaded) {
            return;
        }

        const isCallbackOnly = element.getAttribute([this.ATTRIBUTE_TYPE]) === this.ATTRIBUTE_VALUE_CALLBACK

        if (!isCallbackOnly) {
            this._showImage(element);

            if (element.parentElement instanceof HTMLPictureElement) {
                const sources = element.parentElement.querySelectorAll('source');

                sources.forEach((source) => {
                    source.setAttribute('srcset', source.dataset.srcset);
                    source.dataset.srcset = '';
                });
            }
        }

        // we're lazy loading an image, we need to get its wrapper for the handler, otherwise we need the element itself
        BX.Event.EventEmitter.emit(this.ON_LAZY_LOAD_EVENT_NAME, {
            element: isCallbackOnly ? element : element.closest(`[${this.ATTRIBUTE}="false"]`)
        });

        this.images[element.id].status = this.imageStatus.loaded;
    }

    document.querySelectorAll(`[${BX.LazyLoad.ATTRIBUTE}="false"]`)
        .forEach((element) => BX.LazyLoad.registerImage(element));

    new MutationObserver((entries) => {
        entries.forEach((entry) => {
            const parent = entry.target?.parentElement || entry.target;

            parent.querySelectorAll(`[${BX.LazyLoad.ATTRIBUTE}="false"]`)
                .forEach((element) => BX.LazyLoad.registerImage(element));
        });
    }).observe(document.body, {
        childList: true,
        subtree: true,
    });

    BX.Event.EventEmitter.subscribe(BX.LazyLoad.ON_LAZY_LOAD_EVENT_NAME, (event) => {
        event.data.element.setAttribute(BX.LazyLoad.ATTRIBUTE, 'true');
        event.data.element.querySelector(BX.LazyLoad.LOADER_SELECTOR)?.remove();

        window[event.data.element.getAttribute(BX.LazyLoad.ATTRIBUTE_CALLBACK)]?.call(null, event.data.element);
        delete window[event.data.element.getAttribute(BX.LazyLoad.ATTRIBUTE_CALLBACK)];
    });
});
